export default __webpack_public_path__ + "static/media/phone2.7eeb84ae.svg";